export default __webpack_public_path__ + "static/media/renuma-plus.3fd8c7a0.svg";